import { create } from "zustand";
export var useDownloadPopover = create(function () { return ({
    download: undefined,
    onDone: undefined,
    onCancel: undefined,
}); });
export var getPasswordForDownload = function (download, onDone, onCancel) {
    useDownloadPopover.setState({ download: download, onDone: onDone, onCancel: onCancel });
};
